import { useDeleteWorkTasksMutation } from "@common/api/work-tasks"
import { handleError } from "@common/utils"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { DeleteDialog } from "@/components/layout/list-table-menu"
import useCustomToast from "@/hooks/use-custom-toast"
import { requirePermission } from "@/lib/require-permission"

export const Route = createFileRoute(
  "/_layout/work-orders/$workOrderId/tasks/$taskId/delete",
)({
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(queryClient, "work_task:delete", "/"),
  component: DeleteTaskDialog,
})

function DeleteTaskDialog(): React.ReactElement {
  const { workOrderId, taskId } = Route.useParams()
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const remove = useDeleteWorkTasksMutation()

  const cancel = () =>
    navigate({
      to: "/work-orders/$workOrderId/tasks/$taskId",
      params: { workOrderId, taskId },
      search: true,
    })

  return (
    <DeleteDialog
      noun="task"
      pending={remove.isPending}
      onCancel={cancel}
      onConfirm={() =>
        remove.mutate(
          { work_package_id: workOrderId, deleteWorkTasks: { ids: [taskId] } },
          {
            onSuccess: () => {
              showToast("Deleted", "Task deleted.", "success")
              void navigate({
                to: "/work-orders/$workOrderId",
                params: { workOrderId },
                search: true,
              })
            },
            onError: (error) => handleError(error, showToast),
          },
        )
      }
    />
  )
}
